import React, { useState } from "react";
import "../../css/ContactUs.css";
import hirelocation from "../../images/hirelocation.gif";
import hiretalk from "../../images/hiretalk.gif";
import hiring from "../../images/hiring.png";
import axios from "axios";
import { useSelector } from "react-redux";
import { Helmet } from "react-helmet";
const ContactUs = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
    agree: false,
  });
  const { settingsData } = useSelector((state) => state.settings);
  const [errors, setErrors] = useState({});

  // Function to validate contact form fields before submission
  const validateForm = () => {
    const newErrors = {};

    if (!formData.name.trim()) {
      newErrors.name = "Name is required.";
    }

    if (!formData.email.trim()) {
      newErrors.email = "Email is required.";
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = "Email is invalid.";
    }

    if (!formData.message.trim()) {
      newErrors.message = "Message is required.";
    }
    if (!formData.agree) {
      newErrors.agree =
        "Acceptance is required to submit this form";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // Handle form submission
  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {
      console.log("Form submitted:", formData);
      // alert("Form submitted: " + JSON.stringify(formData, null, 2));
      addContactDetails();
    } else {
      console.log("Validation failed.");
    }
  };

  // Send contact form data to the backend API
  const addContactDetails = async () => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/addContact`,
        formData,
      );

      if (response.status === 201) {
        alert("Contact details added successfully.");
        // Optionally reset the form or state here
        setFormData({
          name: "",
          email: "",
          message: "",
          agree: false,
        });
      } else {
        console.log("Failed to add contact details. Please try again.");
      }
    } catch (error) {
      console.error("Contact Add error:", error);
      setErrors(
        "An error occurred while submitting the form. Please try again later.",
      );
    }
  };

  return (
    <>
      <Helmet>
        <title>Contact Us - SiddhiAnanta Group</title>
        <meta
          name="description"
          content="Get in touch with SiddhiAnanta Group for JDA approved plots, budget-friendly housing, and more. Reach out to us today!"
        />
        <meta
          name="keywords"
          content="Contact SiddhiAnanta, JDA plots Jaipur, real estate contact, SiddhiAnanta Group"
        />
        <meta property="og:title" content="Contact Us - SiddhiAnanta Group" />
        <meta
          property="og:description"
          content="We're here to help you find your dream plot. Contact SiddhiAnanta Group today."
        />
        <meta
          property="og:image"
          content="https://dreamsakha.rusofterp.in/public/webimage/setting/174591535068108dd6e4ebasid.png"
        />
        <meta
          property="og:url"
          content="https://dreamsakha.rusofterp.in/contactUs"
        />
        <meta name="robots" content="index, follow" />
      </Helmet>
      <section className="contact-section">
        <div className="container">
          <div className="row">
            <div className="col-md-6 col-12">
              <div className="contact-txt">
                <h2>Reach Out to Us</h2>
                <h5>We'd Love to Hear From You. Send Us Your Thoughts!</h5>
                <p>
                  Ready to find your ideal plot or have questions about our
                  services? Contact us today and let our dedicated team assist
                  you. Whether you're looking for a JDA approved plot,
                  budget-friendly options, or specific amenities, we're here to
                  help.
                </p>
                <button class="btn" type="button">
                  <a
                    href={`tel:+91${settingsData?.mobile}`}
                    style={{ color: "#fff", textDecoration: "none" }}
                  >
                    <span>Call Us</span>
                  </a>
                </button>
                <button class="btn" type="button">
                  <a
                    href={`mailto:${settingsData?.email}`}
                    style={{ color: "#fff", textDecoration: "none" }}
                  >
                    <span>Email Us</span>
                  </a>
                </button>
              </div>
            </div>
            <div className="col-md-6 col-12">
              <div className="contact-form">
                <div className="formBodyMain">
                  <div className="input-container w-100">
                    <div className="input-wrapper">
                      <input
                        type="text"
                        id="contactname"
                        placeholder=" "
                        value={formData.name}
                        onChange={(e) =>
                          setFormData({ ...formData, name: e.target.value })
                        }
                        className="textField"
                      />
                      <label htmlFor="contactname" className="floating-label">
                        Name <span className="required_field">*</span>
                      </label>
                    </div>
                    {errors.name && (
                      <span className="error-text">{errors.name}</span>
                    )}
                  </div>

                  <div className="input-container w-100 mt-5">
                    <div className="input-wrapper">
                      <input
                        type="text"
                        id="contactemail"
                        placeholder=" "
                        className="textField"
                        value={formData.email}
                        onChange={(e) =>
                          setFormData({ ...formData, email: e.target.value })
                        }
                      />
                      <label htmlFor="contactemail" className="floating-label">
                        Email <span className="required_field">*</span>
                      </label>
                    </div>
                    {errors.email && (
                      <span className="error-text">{errors.email}</span>
                    )}
                  </div>

                  <div className="input-container w-100 mt-5">
                    <div className="input-wrapper">
                      <textarea
                        placeholder=" "
                        id="contactmsg"
                        className="textField"
                        value={formData.message}
                        onChange={(e) =>
                          setFormData({ ...formData, message: e.target.value })
                        }
                      ></textarea>

                      <label htmlFor="contactmsg" className="floating-label">
                        Message <span className="required_field">*</span>
                      </label>
                    </div>
                    {errors.message && (
                      <span className="error-text">{errors.message}</span>
                    )}
                  </div>

                  {/* Checkbox Validation */}
                  <div className="input-container w-100 mt-5">
                    <div className="checkbox-wrapper">
                      <input
                        type="checkbox"
                        id="contactAgree"
                        checked={formData.agree || false}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            agree: e.target.checked,
                          })
                        }
                      />

                      <label htmlFor="contactAgree">
                        I authorize SIDDHIANATA to contact me with updates & notification via Email, SMS & WhatsApp. This will override registry on DNC/NDNC
                        <span className="required_field"> *</span>
                      </label>
                    </div>

                    {errors.agree && (
                      <span className="error-text">{errors.agree}</span>
                    )}
                  </div>
                </div>
                <div className="formFooter mt-5">
                  <button className="subbtn" disabled={!formData.agree} onClick={(e) => handleSubmit(e)}>
                    Submit
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="contactfoot-section sectiontopgap sectionbotgap">
        <div className="container">
          <div className="sectiontitle mb-5">
            <div className="titleunderline">
              <svg
                width="64"
                height="3"
                viewBox="0 0 64 3"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M2 1.5H62"
                  stroke="#F68633"
                  stroke-width="3"
                  stroke-linecap="round"
                />
              </svg>
            </div>
            <h1>We're Hiring!</h1>
            <p className="desk">Join The Glorious Team of SiddhiAnanta Group</p>
            <p className="mob">
              Join The Glorious Team of
              <br />
              SiddhiAnanta Group
            </p>
          </div>

          <div className="row">
            <div className="col-md-6 col-12 hiredatabx">
              <div className="hirebx">
                <div className="hireicon">
                  <img src={hirelocation} className="img-fluid" />
                </div>
                <div>
                  <h4>Our Location</h4>
                  <p>
                    <a href="#">{settingsData.address}</a>
                  </p>
                </div>
              </div>
              {/* </div>
            <div className='col-md-4 col-12'> */}
              <div className="hirebx">
                <div className="hireicon">
                  <img src={hiretalk} className="img-fluid" />
                </div>
                <div>
                  <h4>Let’s Talk</h4>
                  <p>
                    <a href={`tel:+91${settingsData?.mobile}`}>
                      +91-{settingsData.mobile}
                    </a>
                  </p>
                  <p>
                    <a href={`mailto:${settingsData?.email}`}>
                      {settingsData.email}
                    </a>
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-12">
              <div className="hiringbx">
                <img src={hiring} className="hiringbximg" />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ContactUs;
